// API Configuration
// In production, this should point to your deployed backend server
// In development, it uses localhost proxy

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export default API_BASE_URL;
